import { createSelector } from 'reselect';

import { getBetslipIdFromProps } from '../../../../selectors/_propsGetters_';
import { selectEntitiesBetslips } from '../../../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';
import { selectEntitiesMissions } from '../../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import { BetslipStateDataMISSION, BetslipState } from '../../../../states/entities/betslips';
import { Selector } from '../../../../types/selectors';
import { MissionState } from '../../types/state/missions';

const selectCurrentBetslip: Selector<BetslipState | undefined> = createSelector(
  [getBetslipIdFromProps, selectEntitiesBetslips],
  (betslipId, betslips) => (betslipId ? betslips?.[betslipId] : undefined),
);

const selectBetslipMissionDataField: Selector<BetslipStateDataMISSION | null> = createSelector(
  [selectCurrentBetslip],
  (betslip) => betslip?.data?.MISSION ?? null,
);

const selectBetslipMission: Selector<MissionState | undefined> = createSelector(
  [selectBetslipMissionDataField, selectEntitiesMissions],
  (dataField, missions) => {
    const { missionId } = dataField ?? {};

    if (missionId && typeof missionId) {
      return missions[missionId];
    }
  },
);

const selectHistoryBetslipMissionEligibleTagContainerProps = createSelector([selectBetslipMission], (mission) => ({
  label: mission?.title,
}));

export default selectHistoryBetslipMissionEligibleTagContainerProps;
